import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button';
import styles from './style.scss';

const CancelButton = ({ styled, ...rest }) => {
    const { t } = useTranslation('ui');

    if (styled === 'button') {
        return (
            <Button size="small" noborder btnStyle="transparent" {...rest}>
                {t('button.cancel')}
            </Button>
        );
    }

    if (styled === 'backIcon') {
        return (
            <div className={styles.backButton}>
                <Button size="small" noborder btnStyle="transparent" {...rest} />
            </div>
        );
    }

    return null;
};

CancelButton.propTypes = {
    styled: PropTypes.string,
};

CancelButton.defaultProps = {
    styled: 'button',
};

export default CancelButton;
